module.exports = __webpack_public_path__ + "img/illu3@2x.ecc51456.png";